module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k8F2c"))).then(() => parcelRequire('hEqeo'));